export const SENTIMENT_SCORE_DOMAIN_STEP = 0.1;
export const REVIEW_SCORE_DOMAIN_STEP = 5;

// eslint-disable-next-line import/prefer-default-export
export const getAdaptativeDomain = (domain, step, data, key) => {
  const center = (domain[0] + domain[1]) / 2;
  const minLeft = center - step;
  const minRight = center + step;
  const values = data?.map((item) => item[key]) || [];
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);
  // Adds to the left and right half a step to avoid the domain being too close to the data
  const minDomain = Math.floor((minValue - step / 2) / step) * step;
  const maxDomain = Math.ceil((maxValue + step / 2) / step) * step;
  return [
    minLeft !== null ? Math.min(minDomain, minLeft) : minDomain,
    minRight !== null ? Math.max(maxDomain, minRight) : maxDomain,
  ];
};
